import { render, staticRenderFns } from "./ShortcodeGenerator.vue?vue&type=template&id=1232720e&scoped=true&"
import script from "./ShortcodeGenerator.vue?vue&type=script&lang=js&"
export * from "./ShortcodeGenerator.vue?vue&type=script&lang=js&"
import style0 from "./ShortcodeGenerator.vue?vue&type=style&index=0&id=1232720e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232720e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1232720e')) {
      api.createRecord('1232720e', component.options)
    } else {
      api.reload('1232720e', component.options)
    }
    module.hot.accept("./ShortcodeGenerator.vue?vue&type=template&id=1232720e&scoped=true&", function () {
      api.rerender('1232720e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ShortcodeGenerator.vue"
export default component.exports